import axiosInstance from "@/lib/axios";
import {
  LoginResponse,
  RegisterResponse,
  RegisterUserPayload,
  VerifyOtpResponse,
  VerifyOtpPayload,
  ResendOtpPayload,
  ResendOtpResponse,
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  ChangePasswordPayload,
  ChangePasswordResponse,
  ResetPasswordWithOtpPayload,
  ResendForgotPasswordOtpPayload,
  UserDataResponse,
  LoginRequest,
  RefreshTokenResponse,
} from "../types/auth.types";

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await axiosInstance.post<LoginResponse>('/auth/login-user', data, {
      withCredentials: true, // Send cookies for refresh token
    });
    return response.data;
  },

  register: async (data: RegisterUserPayload): Promise<RegisterResponse> => {
    const response = await axiosInstance.post<RegisterResponse>('/auth/register-user', data);
    return response.data;
  },

  verifyOtp: async (data: VerifyOtpPayload): Promise<VerifyOtpResponse> => {
    const response = await axiosInstance.post<VerifyOtpResponse>('/auth/verify-otp', data, {
      withCredentials: true, // Send cookies for refresh token
    });
    return response.data;
  },

  getMe: async (chatbotId:string): Promise<any> => {
    const response = await axiosInstance.get<UserDataResponse>(`/user/dashboard-data/${chatbotId}`);
    return response.data;
  },

  resendOtp: async (data: ResendOtpPayload): Promise<ResendOtpResponse> => {
    const response = await axiosInstance.post<ResendOtpResponse>('/auth/resend-otp', data);
    return response.data;
  },

  forgotPassword: async (data: ForgotPasswordPayload): Promise<ForgotPasswordResponse> => {
    const response = await axiosInstance.post<ForgotPasswordResponse>('/auth/forgot-password', data);
    return response.data;
  },

  resetPasswordWithOtp: async (data: ResetPasswordWithOtpPayload): Promise<{ success: boolean; message: string }> => {
    const response = await axiosInstance.post<{ success: boolean; message: string }>('/auth/reset-password-otp', data);
    return response.data;
  },

  resendForgotPasswordOtp: async (data: ResendForgotPasswordOtpPayload): Promise<{ success: boolean; message: string }> => {
    const response = await axiosInstance.post<{ success: boolean; message: string }>('/auth/resend-forgot-password-otp', data);
    return response.data;
  },

  changePassword: async (data: ChangePasswordPayload): Promise<ChangePasswordResponse> => {
    const response = await axiosInstance.post<ChangePasswordResponse>('/auth/change-password', data);
    return response.data;
  },

  socialLogin: async (idToken: string, rememberMe?: boolean, referralByCode?: string): Promise<LoginResponse> => {
    const response = await axiosInstance.post<LoginResponse>('/auth/social-login', { idToken, rememberMe, referralByCode }, {
      withCredentials: true, // Send cookies for refresh token
    });
    return response.data;
  },

  refreshToken: async (): Promise<RefreshTokenResponse> => {
    const response = await axiosInstance.post<RefreshTokenResponse>('/auth/refresh-token', {}, {
      withCredentials: true, // Send refresh token cookie
    });
    return response.data;
  },

  logout: async (): Promise<void> => {
    await axiosInstance.post('/auth/logout', {}, {
      withCredentials: true, // Send refresh token cookie to revoke
    });
  },

  logoutAllDevices: async (userId: string): Promise<void> => {
    await axiosInstance.post('/auth/logout-all', { userId }, {
      withCredentials: true,
    });
  },

  verifyLogin2fa: async (tempToken: string, otp: string): Promise<LoginResponse> => {
    const response = await axiosInstance.post<LoginResponse>('/auth/verify-login-2fa', { tempToken, otp }, {
      withCredentials: true,
    });
    return response.data;
  },

  resendLogin2fa: async (tempToken: string): Promise<any> => {
    const response = await axiosInstance.post('/auth/resend-login-2fa', { tempToken });
    return response.data;
  },

  toggle2fa: async (isTwoFactorEnabled: boolean, password?: string): Promise<any> => {
    const response = await axiosInstance.post('/auth/toggle-2fa', { isTwoFactorEnabled, password }, {
      withCredentials: true,
    });
    return response.data;
  },
};
